import React from 'react';
import {FMessage} from '../../hoc/IntlComponents';

const shippingHref = 'https://www.ponyexpress.ru/support/servisy-samoobsluzhivaniya/track/?trace_ids=';

const ContractShipping = ({el_props}) => {
  if(el_props.status !== 15 || !el_props.shipper.track_code) {
    return null;
  }

  return (
    <div className='contracts-shipping-block'>
      <div><b><FMessage id='contracts.item.shipping.title'/></b> {el_props.shipper.track_code}</div>
      <div>
        <FMessage id='contracts.item.shipping.track'/>&nbsp;
        <a href={shippingHref + el_props.shipper.track_code} target='_blank'>
          <FMessage id='contracts.item.shipping.here'/>
        </a>
      </div>
    </div>
  );
};

export default ContractShipping;